export default __webpack_public_path__ + "static/image2-48e1882ebeab0b60273cef2377b69879.gif";